function getBaseDomainURL(bid = null) {
  const domain = !!bid ? bid : localStorage.getItem('business_domain');
  const baseDomainURL = `/c/${domain}`;
  return baseDomainURL;
}
export default getBaseDomainURL;
